export const DELIVERY_PROGRESS_COLOR = Styles.color.primary;
export const DESKTOP_DELIVERY_BANNER_BACKGROUND = Styles.color.white;
